export const languages: any = {
  "en": "English",
  "es": "Spanish",
  "fr": "French",
  "de": "German",
  "nl": "Dutch",
  "pt": "Portuguese",
  "ru": "Russian"
};
